import React, { useState, useEffect } from "react";
import { useQuery } from "react-query";
import { useSelector } from "react-redux";

import AppLoader from "../common/Loader/AppLoader";
import styles from "./ManageSubscriptions.module.scss";
import { getSiteBuilderPlan } from "../../api";
import { TTP_ONBOARDING_URL, TTP_PAYMENT_URL } from "../../config";
import Button from "../common/Button";
import SubscriptionModal from "./SubscriptionModal";
import _ from "../../i18n";

const ManageSubscriptions = () => {
  const token = useSelector((state) => state.auth.token);
  const fiduciary = useSelector((state) => state.folder.fiduciary);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [newPlan, setNewPlan] = useState(null);
  const [showSuccessMsg, setShowSuccessMsg] = useState(false);

  // const paymentSuccess = new URLSearchParams(window.location.search).get("paymentSuccess");

  useEffect(() => {
    const url = new URL(window.location.href);
    if (url.searchParams.get("paymentSuccess")) {
      setShowSuccessMsg(true);
      url.searchParams.delete("paymentSuccess");
      history.replaceState(null, "", url.href);
    }
  }, []);

  const { isLoading, data } = useQuery(
    ["getPlans", token, fiduciary],
    async () => {
      if (token && fiduciary) {
        const response = await getSiteBuilderPlan(token, fiduciary.id);

        if (response.data.data?.formulas) {
          const url = new URL(window.location.href);
          if (
            url.searchParams.get("showModal") &&
            url.searchParams.get("plan")
          ) {
            if (url.searchParams.get("showModal") == "site_builder") {
              const planId = parseInt(url.searchParams.get("plan"));
              let plan = response.data.data.formulas.filter(
                (i) => i.id === planId
              );

              if (plan.length === 1) {
                setNewPlan(plan[0]);
                setIsOpenModal(true);
              }

              url.searchParams.delete("showModal");
              url.searchParams.delete("plan");
              history.replaceState(null, "", url.href);
            }
          }
        }

        return response.data.data;
      }
    }
  );

  return (
    <>
      {/* <BackButton
        onClick={() => (window.location = `${TTP_ONBOARDING_URL}/settings`)}
        title={_("manage_account")}
      /> */}
      {isLoading && <div className="lmask" />}
      {showSuccessMsg && (
        <div className={styles.success_banner}>
          <span className={`${styles.check_icon} ${styles.green}`}>
            <i className="icon-ttp-check"></i>
          </span>{" "}
          Abonnement confirmé : votre paiement a été effectué avec succès.
        </div>
      )}
      <div className="grid-container">
        <h1 className={styles.pageTitle}>Gérer mes abonnements</h1>
        <p className={styles.pageHelpTitle}>
          Retrouvez et gérez l’ensemble de vos abonnements United Associates
          ici.
        </p>

        <h3>Site Builder</h3>

        {data?.formulas && (
          <>
            <div className={styles.plans}>
              {data.formulas.map((i) => (
                <div key={`plan${i.id}`} className={`${styles.plans_item}`}>
                  <div>
                    <div className={styles.plan_top}>
                      {data.selected && data.selected.id === i.id && (
                        <div className={styles.selected_tag}>
                          <span className={styles.check_icon}>
                            <i className="icon-ttp-check"></i>
                          </span>{" "}
                          Appliqué
                        </div>
                      )}
                      <div className={styles.plan_app}>Site Builder</div>
                      <h3 className={styles.plan_name}>{i.nameFr}</h3>

                      <span className={styles.plan_tag}>
                        {i.monthPrice === 0 ? (
                          "Gratuit"
                        ) : (
                          <>
                            <span>{i.monthPrice + " €"}</span> par mois
                          </>
                        )}
                      </span>
                    </div>
                    <ul>
                      {i.options.map((option, idx) => (
                        <li
                          key={`opt${idx}`}
                          className={`${styles.plan_option}`}
                        >
                          <i className="icon-ttp-check" />
                          <span
                            dangerouslySetInnerHTML={{ __html: option }}
                          ></span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  {data.selected && (
                    <>
                      {i.id !== data.selected.id &&
                        i.monthPrice > data.selected.monthPrice && (
                          <div className={styles.plan_actions}>
                            <Button
                              onClick={() => {
                                setNewPlan(i);
                                setIsOpenModal(true);
                              }}
                            >
                              S’abonner au plan {i.nameFr}
                            </Button>
                          </div>
                        )}
                      {i.id === data.selected.id && i.monthPrice > 0 && (
                        <>
                          <div className={styles.plan_actions}>
                            <div className={styles.plan_infos}>
                              <p>
                                {data.selected.period === "MONTHLY"
                                  ? "Abonnement mensuel actif."
                                  : "Abonnement annuel actif."}
                              </p>
                              {data.selected.nextDebitDate && (
                                <p>
                                  Prochain renouvellement le{" "}
                                  {data.selected.nextDebitDate}.
                                </p>
                              )}
                            </div>
                            <div
                              className={styles.alt_btn}
                              onClick={() => {
                                setNewPlan(i);
                                setIsOpenModal(true);
                              }}
                            >
                              Voir mes factures
                            </div>
                          </div>
                          <div className={styles.plan_cancel_btn}>
                            Résilier mon abonnement
                          </div>
                        </>
                      )}
                    </>
                  )}
                </div>
              ))}
            </div>
          </>
        )}
      </div>

      <SubscriptionModal
        isOpen={isOpenModal}
        closeModal={() => {
          setIsOpenModal(false);
        }}
        newPlan={newPlan}
        currentPan={data?.selected ?? null}
        fiduciary={fiduciary}
        token={token}
      />
    </>
  );
};

export default ManageSubscriptions;
